<template>
  <div class="bottomVert" v-if="detailReseauxTempo.listeFaces.length">
    <gmap-map
      class="infoBorder gmap"
      :center="{
        lat: detailReseauxTempo.latitude,
        lng: detailReseauxTempo.longitude
      }"
      :zoom="12"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      ref="mapReseauxTempo"
      @tilesloaded="initCarto">
      <gmap-marker
        v-for="(m, index) in detailReseauxTempo.listeFaces"
        :key="index"
        :clickable="true"
        :position="{
          lat: m.latitude,
          lng: m.longitude
        }"
        @click="detailFace = m, show = true"
        @mouseover="handleMarkerHover(m, index)"
        :icon="icon(detailReseauxTempo.couleur, m)">
      </gmap-marker>
      <gmap-marker
        v-if="markerReseauxTempo.lat"
        :position="{
          lat: markerReseauxTempo.lat,
          lng: markerReseauxTempo.lng,
        }"
        :icon="markerReseauxTempo.icon">
      </gmap-marker>

      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen = false"
      >
        <div v-html="infoContent"></div>
      </gmap-info-window>
    </gmap-map>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <app-detail-tempo :bg="bg" :detailFace="detailFace" v-if="show"/>
    </transition>
  </div>
</template>

<script>
import { iconColorGetter, TAILLE_ICON_GRAND, TAILLE_ICON_PETIT } from '@/services/general/iconColorGetter';
import {
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import filterLatLng from '@/services/general/gestionLatLng';
import fullscreenPopupMixin from '@/services/general/fullscreenPopupMixin';
import detailTempo from './detailTempo';

export default {
  name: 'carteReseauxTempo',
  mixins: [fullscreenPopupMixin],
  components: {
    appDetailTempo: detailTempo,
  },
  props: ['detailReseauxTempo', 'markerReseauxTempo'],
  data() {
    return {
      detailFace: {},
      show: false,
      colorIcon: '#49db70',
      bg: false,
      isLoadOnce: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
    };
  },
  methods: {
    async levelZoom() {
      const bounds = new google.maps.LatLngBounds();
      filterLatLng(this.detailReseauxTempo.listeFaces);
      this.detailReseauxTempo.listeFaces.forEach(m => {
        if (m.latitude !== 0 && m.longitude !== 0
        && m.latitude !== null && m.longitude !== null) {
          bounds.extend({ lat: m.latitude, lng: m.longitude });
        }
      });
      if (this.markerReseauxTempo !== undefined && this.markerReseauxTempo.lat !== undefined) {
        bounds.extend({ lat: this.markerReseauxTempo.lat, lng: this.markerReseauxTempo.lng });
      }
      this.$refs.mapReseauxTempo.fitBounds(bounds);
    },
    icon(color, face) {
      const icon = iconColorGetter(color || this.colorIcon,
        ['3', '4'].includes(face.formatCode) ? TAILLE_ICON_GRAND : TAILLE_ICON_PETIT, face.azimut, true);
      return icon;
    },
    async initPoi() {
      const map = await this.$refs.mapReseauxTempo.$mapPromise;
      const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
        name: MAP_TYPE_NAME,
      });
      map.mapTypes.set('styled_map', styleMap);
    },
    async initCarto() {
      if (!this.isLoadOnce) {
        await this.initPoi();
        if (this.detailReseauxTempo.listeFaces.length) {
          await this.levelZoom();
        }
        this.isLoadOnce = true;
      }
    },
    getInfoWindowContent(marker) {
      const adresse = this.buildAdresse(marker);

      return (
        `<div style="padding:15px" class="card">
          <div class="">
            <div class="columns">
              <div class="column is-6">
                <p>Code Face : <strong>${marker.facCode || ''}</strong></p>
                <p>Réseau : <strong>${this.detailReseauxTempo.libelle || ''}</strong></p>
                <p>Adresse : <strong>${adresse}</strong></p>
                <p>Format : <strong>${marker.format || ''}</strong></p>
              </div>
              <div class="column">
                <img style="width:100%"
                    src="${marker.urlPhoto ? marker.urlPhoto : this.defaultPlaceholder}"/>
              </div>
            </div>
          </div>
        </div>`);
    },
  },
  mounted() {
    if (this.detailReseauxTempo.latitude === null || this.detailReseauxTempo.longitude === null) {
      this.detailReseauxTempo.latitude = 0;
      this.detailReseauxTempo.longitude = 0;
    }
    this.setupFullscreenListeners();
  },
  beforeDestroy() {
    this.removeFullscreenListeners();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxTempo/carteReseauxTempo.vue